export default __webpack_public_path__ + "static/media/003-round-shot.b6f2bb10.png";